import '../../external/jquery/jquery-ajaxq-end.js'; // to modify jquery object
import './interaction.js'; // for side effects on doc load


$(function () {
    $.getJSON(baseCacheURL + 'about/impact.json', function (data) {
        $('#js-percentage-schools').html($.parseJSON(data.stats.publicSchools) + '% of US public schools');
        $('#js-percentFunded').html($.parseJSON(data.stats.percentFullyFunded) + '% of projects');
    });
});
